// API
// ----------------------------------------------------------------------

export const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL || '';
export const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
export const REACT_APP_CONNECT_BASE_URL = process.env.REACT_APP_CONNECT_BASE_URL || '';
export const REACT_APP_CLIENT_BASE_URL = process.env.REACT_APP_CLIENT_BASE_URL || '';
export const REACT_APP_NOTIFICATION_URL = process.env.REACT_APP_NOTIFICATION_URL || '';
export const REACT_APP_API_CONNECT_BASE_URL = process.env.REACT_APP_API_CONNECT_BASE_URL || '';
